import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'The Emergency PE Lesson Pack',
    desc: '30 ready-to-teach sessions for the days when you have zero time to plan. Grab a page. Go teach.',
    val: '$80'
  }, {
    num: '02',
    title: 'The No-Prep PE Games Vault',
    desc: '30 high-energy games that require zero equipment. Run them anywhere, anytime, with any group size.',
    val: '$100'
  }, {
    num: '03',
    title: 'PE Assessment Made Easy',
    desc: '30 plug-and-play assessment pages to track skills, effort, and progress without drowning in paperwork.',
    val: '$70'
  }, {
    num: '04',
    title: 'The Yearly PE Planning Calendar',
    desc: 'Your entire school year structured from Day 1 to Day 180. Stop guessing what to teach next.',
    val: '$90'
  }, {
    num: '05',
    title: "The PE Teacher's Time-Saving Toolkit",
    desc: '30 practical hacks to reclaim 5 hours of your week, manage discipline, and run your class like a pro.',
    val: '$60'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-ink mb-4" data-id="element-18">
            🎁 Exclusive{' '}
            <span className="text-brand-accent" data-id="element-19">
              Strategic Bonuses Included
            </span>
          </h2>
          <p className="text-lg text-brand-muted font-medium" data-id="element-20">
            Only when purchasing today, you will receive at no extra cost:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 border border-brand-border relative overflow-hidden shadow-sm" data-id="element-22">
              <div className="text-6xl font-heading font-black text-brand-gold/10 absolute top-3 right-4 leading-none" aria-hidden="true" data-id="element-23">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-24">
                <div className="text-brand-gold font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-25">
                  BONUS #{bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-brand-ink mb-3 pr-10 leading-tight" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-brand-muted mb-6 text-sm leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-brand-border" data-id="element-28">
                  <div className="text-brand-muted line-through text-sm" data-id="element-29">
                    Value {bonus.val}
                  </div>
                  <div className="text-white font-black text-sm bg-brand-accent px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-30">
                    FREE
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-card rounded-2xl p-8 text-center border border-brand-gold/30 max-w-2xl mx-auto shadow-sm" data-id="element-31">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-32">
            🎁 FREE BONUSES — Limited time only
          </h3>
          <p className="text-brand-muted font-medium" data-id="element-33">
            Included in every offer. Always.
          </p>
        </div>
      </div>
    </section>;
}